import { Component } from '@angular/core';
import { Connect } from '../../../classes/connect';
import { ConnectServerService } from '../../../services/connect-server.service';
import { PopupDialogService } from '../../../services/popup-dialog.service';
import { ApiResponse } from '../../../interfaces/api-response';

@Component({
  selector: 'app-import-file',
  imports: [],
  templateUrl: './import-file.component.html',
  styleUrl: './import-file.component.scss'
})
export class ImportFileComponent {

  constructor(
    private connectServerService: ConnectServerService,
    private popupDialogService: PopupDialogService
  ) { }

  uploadFiles(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = input.files;
    if (!files) {
      return;
    }

    let messaggio = '';
    for (const file of Array.from(files)) {
      if (file.size < Connect.sizeFileExcel) {
        const formData = new FormData();
        formData.append('allegato', file);
        this.connectServerService
          .postRequest('importRegProvCit', formData, Connect.urlServerLaraApi)
          .subscribe((res: ApiResponse<any>) => {
            this.popupDialogService.popupDialog(res);
          });
      } else {
        messaggio += `Impossibile caricare il file ${file.name}\n`;
      }
    }

    if (messaggio.length > 0) {
      alert(`${messaggio}Dimensione consentita per ogni file: ${Connect.str_sizeFileExcel}\n`);
    }

    input.value = '';
  }

}
